import React, { useEffect } from 'react';
import './DeliveryInfoBottomSheet.css';

const DeliveryInfoBottomSheet = ({ isOpen, onClose }) => {
    // Prevent scrolling on body when bottom sheet is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <>
            <div className={`delivery-info-overlay ${isOpen ? 'show' : ''}`} onClick={onClose}></div>
            <div className={`delivery-info-bottom-sheet ${isOpen ? 'show' : ''}`}>
                <div className="delivery-info-sheet-header">
                    <div className="delivery-info-drag-handle" onClick={onClose}></div>
                    <button className="delivery-info-close-btn" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                
                <div className="delivery-info-sheet-content">
                    <div className="delivery-info-header-section">
                        <h1 className="delivery-info-title delivery-info-font-heading">Delivery Information</h1>
                    </div>

                    <div className="delivery-info-section">
                        <h3 className="delivery-info-font-heading">HOW IT WORKS</h3>
                        <p>We partner with trusted UK courier services.</p>
                        <p>Our packaging is designed to keep groceries safe and fresh.</p>
                    </div>

                    <div className="delivery-info-section">
                        <h3 className="delivery-info-font-heading">SCHEDULING A DELIVERY</h3>
                        <p>Some items may allow scheduled delivery during checkout.</p>
                        <p>Contact us 24 hours prior if you need to change the delivery slot.</p>
                    </div>

                    <div className="delivery-info-section">
                        <h3 className="delivery-info-font-heading">CONTACTLESS DELIVERY</h3>
                        <p>Available upon request. </p>
                        <p>Your order will be left at your door or with building reception/security.</p>
                    </div>

                    <div className="delivery-info-section">
                        <h3 className="delivery-info-font-heading">LIVE DRIVER TRACKING </h3>
                        <p>For local rapid deliveries, you’ll receive a real-time tracking link and map once your rider is en route.</p>
                    </div>

                    <div className="delivery-info-section">
                        <h3 className="delivery-info-font-heading"> FAQs</h3>
                        <ul>
                            <li><strong>Do I need to be home?</strong>Yes—unless you choose contactless delivery. </li>
                            <li><strong>Can I change the delivery address later? </strong> Only before dispatch. Contact support ASAP. </li>
                            <li><strong>What if my order is delayed? </strong>We’ll notify you with an updated delivery estimate. 
</li>
                        </ul>
                    </div>

                </div>
            </div>
        </>
    );
};

export default DeliveryInfoBottomSheet;
